<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { reactive, ref, toRaw } from 'vue';

import KTextField from '@/components/fields/KTextField.vue';
import SuburbAutocompleteField from '@/components/fields/SuburbAutocompleteField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  name?: string;
  line2?: string;
  line1?: string;
  suburb?: openapi.SuburbOpenapi | null;
}

export interface ValidData {
  name?: string;
  line2?: string;
  line1?: string;
  suburb: openapi.SuburbOpenapi;
}

export interface Props {
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  emit('submit', event, toRaw(formData) as ValidData);
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.addAddressDialogForm"
    data-testid="addAddressDialogForm"
    @submit.prevent="handleSubmit"
  >
    <KTextField
      v-model="formData.name"
      label="Address name"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <KTextField
      v-model="formData.line2"
      label="Street address"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <KTextField
      v-model="formData.line1"
      label="Room / Level / Unit"
      :class="$style.field"
    />
    <SuburbAutocompleteField
      v-model="formData.suburb"
      :rules="[requiredValidationRule]"
      :class="[$style.field, $style.suburbField]"
    />
    <input type="submit" class="hidden" />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.addAddressDialogForm {
}
  .field {
  }
</style>
